import {
    MonitorPlay,
    PlayCircle,
    CalendarDays,
    Clock,
    Award,
    Smartphone,
} from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { PREMIERE_DATE } from "../config/site";

const POINTS = [
    { icon: MonitorPlay, text: "100 lekcji w formie nagrań - oglądasz w swoim tempie" },
    { icon: PlayCircle, text: "Nagrania dostępne o dowolnej porze dnia i nocy" },
    { icon: CalendarDays, text: `Dostęp rusza w dniu premiery - ${PREMIERE_DATE}` },
    { icon: Clock, text: "Standardowy dostęp trwa 10 miesięcy" },
    { icon: Award, text: "Imienny certyfikat PDF po ukończeniu" },
    { icon: Smartphone, text: "Komputer, tablet i telefon" },
];

const TINTS = ["bg-tang", "bg-hl-pink", "bg-hl-cyan", "bg-hl-lav", "bg-hl-pink", "bg-hl-cyan"];

export const Platform = () => (
    <section
        id="platforma"
        data-testid="platform-mockup-section"
        className="py-20 sm:py-28 bg-cream-deep overflow-hidden"
    >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
            <div>
                <SectionHeading
                    kicker="Platforma online"
                    title="Oglądasz wtedy, kiedy masz czas"
                    lead="Cały kurs czeka na Ciebie na platformie EduNation - bez terminów, bez stresu, w Twoim tempie."
                />
                <ul className="mt-10 grid sm:grid-cols-2 gap-x-8 gap-y-6">
                    {POINTS.map((p, i) => (
                        <Reveal key={p.text} delay={i * 0.06}>
                            <li
                                data-testid={`platform-point-${i + 1}`}
                                className="flex gap-3 items-start"
                            >
                                <span
                                    className={`shrink-0 inline-flex items-center justify-center w-11 h-11 rounded-full text-ink ${TINTS[i]}`}
                                >
                                    <p.icon className="w-5 h-5" />
                                </span>
                                <span className="text-sm text-ink/80 font-medium leading-relaxed pt-2">
                                    {p.text}
                                </span>
                            </li>
                        </Reveal>
                    ))}
                </ul>
            </div>
            <Reveal delay={0.1}>
                <div className="relative">
                    <div className="absolute -top-6 -right-4 w-32 h-32 bg-hl-lav rounded-[2rem] rotate-6" />
                    <div className="absolute -bottom-8 -left-4 w-36 h-36 bg-hl-cyan rounded-full" />
                    <div className="relative mx-auto max-w-lg w-full">
                        <div className="rounded-[1.8rem] bg-ink p-2.5 shadow-card">
                            <div className="rounded-[1.25rem] bg-white overflow-hidden">
                                <div className="flex items-center gap-2 px-4 py-3 border-b border-border">
                                    <span className="w-2.5 h-2.5 rounded-full bg-hl-pink" />
                                    <span className="w-2.5 h-2.5 rounded-full bg-tang" />
                                    <span className="w-2.5 h-2.5 rounded-full bg-hl-cyan" />
                                </div>
                                <div className="p-5 sm:p-7 grid grid-cols-[1.25fr_1fr] gap-5 items-center">
                                    <div>
                                        <span className="inline-block rounded-full bg-hl-lav px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-ink">
                                            Kurs online
                                        </span>
                                        <p className="font-display uppercase font-extrabold text-ink text-xl sm:text-2xl leading-[1.3] mt-3">
                                            <span className="inline-block bg-tang px-2.5 py-1 rounded-md -rotate-1">
                                                100 rozwiązań
                                            </span>
                                            <span className="inline-block bg-hl-pink px-2.5 py-1 rounded-md rotate-[0.5deg] mt-2">
                                                na trudne sytuacje
                                            </span>
                                            <span className="inline-block bg-hl-cyan px-2.5 py-1 rounded-md -rotate-[0.5deg] mt-2">
                                                na lekcji z dorosłymi
                                            </span>
                                        </p>
                                    </div>
                                    <img
                                        src="/images/new1.webp"
                                        alt="Anna Popławska i Luiza Wójtowicz-Waga - trenerki kursu"
                                        loading="lazy"
                                        data-testid="platform-mockup-image"
                                        className="w-full h-48 sm:h-56 object-cover object-top rounded-xl"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="mx-auto h-3.5 w-[106%] -ml-[3%] rounded-b-2xl rounded-t-sm bg-gradient-to-b from-[#2A3160] to-ink" />
                        <div className="mx-auto mt-1 h-1.5 w-24 rounded-full bg-ink/10" />
                    </div>
                    <span className="absolute -bottom-4 right-6 rounded-full bg-tang text-ink px-4 py-2 text-xs font-bold uppercase tracking-wider shadow-md">
                        Dostęp 10 miesięcy
                    </span>
                </div>
            </Reveal>
        </div>
    </section>
);
